<script>
  import { onMount } from "svelte";
  import { fade } from "svelte/transition";
  import SmallButton from "../SmallButton/SmallButton.svelte";
  import UpcomingEventsListItem from "./UpcomingEventsListItem/UpcomingEventsListItem.svelte";
  let pageNumber = 1;
  let requestPending = false;
  let pageSize = 5;
  let moreEventsAvailable = false;
  let events = [];
  let error = false;
  let loc = window.localStorage.getItem("wglang") || "de";
  
  function handleLoadMore() {
    if (moreEventsAvailable && !requestPending) {
      pageNumber += 1;
      fetchEvents();
    }
  }

  async function fetchEvents() {
    try {
      requestPending = true;
      const eventsRequest = await fetch(
        `${API_URL}/events?pageSize=${pageSize}&pageNumber=${pageNumber}&include=unpublished-upcoming`
      );

      if (eventsRequest.status === 200) {
        const data = await eventsRequest.json();
        events = [...events, ...data.results];
        moreEventsAvailable = data.totalPages > pageNumber;
      } else {
        throw new Error("API returned unexpected status.");
      }
      requestPending = false;
    } catch (e) {
      requestPending = false;
      console.log(e);
      error = true;
    }
  }

  onMount(async () => {
    fetchEvents();
  });

  window.setLanguageUpcomingEvents = (lan) => {
    loc = lan;
  }
</script>

<div>
  {#if !error}
    <ul class="c-upcoming-events">
      {#each events as event}
        <li transition:fade>
          <UpcomingEventsListItem {...event} loc={loc}/>
        </li>
      {/each}
    </ul>
    {#if moreEventsAvailable}
      <div class="c-upcoming-events__load-more-wrap">
        <SmallButton onClick={handleLoadMore} disabled={requestPending}>
          {#if loc === 'en'} Load more
          {:else} Mehr laden
          {/if}
        </SmallButton>
      </div>
    {/if}
  {:else}
  <p>{#if loc === 'en'} Oops, something went wrong
    {:else} Da ist was schief gelaufen.
    {/if}</p>
  {/if}
</div>

<style>
  .c-upcoming-events {
    list-style: none;
    padding: 0;
    width: 570px;
    max-width: 100%;
    margin: 0 auto;
  }

  .c-upcoming-events li {
    margin-bottom: 0;
    margin-left: 0;
    padding-left: 0;
    padding-bottom: 24px;
    padding-top: 24px;
    border-top: 1px solid var(--neutral-200);
  }

  .c-upcoming-events li:first-child {
    border-top: none;
  }

  .c-upcoming-events__load-more-wrap {
    padding: 32px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
